// Chakra v3 doesn't have useBreakpointValue, so we implement our own using media queries
import { useEffect, useState } from "react";

// Match the breakpoints defined in the theme
const breakpoints = {
  base: "0px",
  xs: "576px",
  sm: "768px",
  md: "1024px",
  lg: "1200px",
  xl: "1440px",
  "2xl": "1600px",
} as const;

export function useBreakpointValue<T = unknown>(
  values: Partial<Record<string, T>> | T[]
): T | undefined {
  const [currentBreakpoint, setCurrentBreakpoint] = useState<string>("base");

  useEffect(() => {
    const updateBreakpoint = () => {
      const width = window.innerWidth;

      if (width >= 1600) setCurrentBreakpoint("2xl");
      else if (width >= 1440) setCurrentBreakpoint("xl");
      else if (width >= 1200) setCurrentBreakpoint("lg");
      else if (width >= 1024) setCurrentBreakpoint("md");
      else if (width >= 768) setCurrentBreakpoint("sm");
      else if (width >= 576) setCurrentBreakpoint("xs");
      else setCurrentBreakpoint("base");
    };

    updateBreakpoint();
    window.addEventListener("resize", updateBreakpoint);
    return () => window.removeEventListener("resize", updateBreakpoint);
  }, []);

  if (Array.isArray(values)) {
    const breakpointKeys = Object.keys(breakpoints);
    const currentIndex = breakpointKeys.indexOf(currentBreakpoint);

    // Find the closest value at or before current breakpoint
    for (let i = currentIndex; i >= 0; i--) {
      if (values[i] !== undefined) {
        return values[i];
      }
    }
    return values[0];
  }

  // Handle object format
  const breakpointKeys = Object.keys(breakpoints);
  const currentIndex = breakpointKeys.indexOf(currentBreakpoint);

  // Find the closest value at or before current breakpoint
  for (let i = currentIndex; i >= 0; i--) {
    const key = breakpointKeys[i];
    if (values[key] !== undefined) {
      return values[key];
    }
  }

  return values.base;
}
